import { useEffect, useState } from "react";
import ProfileSection from "../../../../common/profile/Profile";

import PaymentInfo from "./payment_info/PaymentInfo";
import Button from "../../../../common/buttons/Button";

import DatePicker from "../../../../common/datepicker/DatePicker";

import { useFormik } from "formik";
import * as Yup from "yup";
import {
  addMedBill,
  deleteMedBill,
  getInvoicePrint,
  getMedBillInvoicePrint,
  getMedPaymentTransactionHistory,
  getPendingInvoices,
  getPendingMedInvoices,
  getPrescriptionPrint,
  updateMedBill,
} from "../../../../../api/Payment";
import { useNavigate } from "react-router-dom";

import { showErrorToast, showSuccessToast } from "../../../../../utils/toaster";
import { formatDate } from "../../../../../utils/date";

import {
  getMedDetails,
  getBatchDetails,
  getAllMedicines,
} from "../../../../../api/settings/Medicines/medicines";
import ServiceMedicineInfo from "./service_treatment_Info/ServiceTreatmentInfo";
import BatchDetails from "./batch-details";
import ModalWrapper from "../../../../common/modal/ModalWrapper";
import PasswordConfirmModal from "../../../../common/modal/PasswordConfirmModal";

import CheckMarkWhite from "../../../../icons/CheckMarkWhite.js";
import Whatsapp from "../../../../icons/Whatsapp.js";
import SMS from "../../../../icons/SMS.js";
import {
  sendInvoiceMessage,
  sendMedBillInvoiceMessage,
  sendNextappointmentMessage,
  sendPrescriptionMessage,
} from "../../../../../api/communication/index.js";
import { openWhatsappMessager } from "../../../../../utils/opneWhatsapp.js";
import Printer from "../../../../icons/Printer.js";
import PaymentTransaction from "../PaymentDetails/pendint_bills/PaymentTransactions.js";
import dayjs from "dayjs";

// Round money to 2 decimals — kills float drift like 5.6 * 4 = 22.400000000000002.
const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;
// Round the payable to the nearest whole number (no decimals): 22.4 -> 22, 22.5 -> 23.
// Same policy as the CREATE bill page — Total + Balance only; line amounts stay exact.
const roundWhole = (n) => Math.round(Number(n) || 0);

const treatmentInfo = {
  name: "",
  amount: null,
  quantity: null,
};

const initialValues = {
  patient_id: "",
  date: new Date(),
  treatment_done_info: [treatmentInfo],
  treatment_amount: null,
  total_amount: null,
  discount: "",
  paymentIn: {
    date: new Date(),
    cash: 0,
    upi: 0,
    card: 0,
    bankTransfer: 0,
    amountPaid: 0,
    notes: "",
  },
};

const validationSchema = Yup.object().shape({
  date: Yup.string().required("Date is required"),
  treatment_done_info: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("Treatment name is required"),
      amount: Yup.number().required("required"),
    })
  ),
  treatment_amount: Yup.number().required("required"),
  total_amount: Yup.number().required("required"),
  balance_amount: Yup.number().notRequired(),
  discount: Yup.number().notRequired(),
  paymentIn: Yup.object().shape({
    date: Yup.string().required("Payment date is required"),
    cash: Yup.mixed()
      .test(
        "is-number-or-empty",
        "Please enter a valid amount",
        (value) => value === "" || typeof value === "number"
      )
      .required("Please enter a valid amount"),
    upi: Yup.mixed()
      .test(
        "is-number-or-empty",
        "Please enter a valid amount",
        (value) => value === "" || typeof value === "number"
      )
      .required("Please enter a valid amount"),
    card: Yup.mixed()
      .test(
        "is-number-or-empty",
        "Please enter a valid amount",
        (value) => value === "" || typeof value === "number"
      )
      .required("Please enter a valid amount"),
    bankTransfer: Yup.mixed()
      .test(
        "is-number-or-empty",
        "Please enter a valid amount",
        (value) => value === "" || typeof value === "number"
      )
      .required("Please enter a valid amount"),
    amountPaid: Yup.number().required("required"),
    notes: Yup.string().notRequired(),
  }),
});

const MedicinePaymentDetailsLayout = ({
  details,
  getInvoiceDetails,
  prescription,
  next_appointment,
}) => {
  const [patientId, setPatientId] = useState(details?.patient_id?._id || "");
  const [pendingInv, setPendingInv] = useState([]);
  const [loading, setLoading] = useState(false);
  const [treatments, setTreatments] = useState([]);
  const [search, setSearch] = useState("");

  const [batchDetails, setBatchDetails] = useState([]);
  const [medicines, setMedicines] = useState([]);
  const [openBatchDetails, setOpenBatchDetails] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({});
  const [communicationChannel, setCommunicationChannel] = useState({
    whatsapp: details?.patient_id?.whatsapp || false,
    sms: details?.patient_id?.sms || false,
  });
  const [edit, setEdit] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [invoiceSendSuccess, setInvoiceSendSuccess] = useState(false);
  const [nextAppntSendSuccess, setNextAppntSendSuccess] = useState(false);
  const [prescriptionSendSuccess, setPrescriptionSendSuccess] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [nextAppntLoading, setNextAppntLoading] = useState(false);
  const [prescriptionLoading, setPrescriptionLoading] = useState(false);
  const [loadingPrintPrescription, setLoadingPrintPrescription] =
    useState(false);
  const [loadingPrintInvoice, setLoadingPrintInvoice] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [status, setStatus] = useState("");

  const navigation = useNavigate();

  const handleWhatsappClick = () => {
    setCommunicationChannel((prevState) => ({
      ...prevState,
      whatsapp: !prevState.whatsapp, // Toggle the value
    }));
  };

  const handleSmsClick = () => {
    setCommunicationChannel((prevState) => ({
      ...prevState,
      sms: !prevState.sms, // Toggle the value
    }));
  };
  const handleconfirmation = (props) => {
    setConfirmOpen(!confirmOpen);
  };

  const handleEdit = () => {
    setEdit(!edit);
  };

  const handleGetBatchDetails = (item_id) => {
    setBatchDetails([]);
    getBatchDetails({ id: item_id })
      .then((response) => {
        setBatchDetails(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };
  const getPaymentHistory = () => {
    if (details?._id) {
      setPaymentHistory([]);
      getMedPaymentTransactionHistory(details?._id)
        .then((response) => {
          setPaymentHistory(response.data.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  const handleGetMedDetails = (item) => {
    // Prefer the line's existing inventory link — resolves by id, so it works
    // for special-char names ("Aceclofenac + Paracetamol") and renamed items,
    // and can't pick the wrong [0] match. Name lookup is only the fallback
    // for rows that carry no link yet.
    const linkedId = item?.item_id || item?.batches?.[0]?.item_id;
    if (linkedId) {
      handleGetBatchDetails(linkedId);
      setSelectedRowData({ ...item, _id: linkedId });
      setOpenBatchDetails(true);
      return;
    }
    getMedDetails({ search: item.name })
      .then((response) => {
        if (response.data.data.length > 0) {
          const data = response.data.data[0];
          handleGetBatchDetails(response.data.data[0]._id);
          setSelectedRowData({ ...item, _id: response?.data?.data?.[0]?._id });
          setOpenBatchDetails(true);
        } else {
          setBatchDetails([]);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    if (details && (details?.sendWhatsapp || details?.sms)) {
      setInvoiceSendSuccess(true);
    }
    if (prescription && (prescription?.sendWhatsapp || prescription?.sms)) {
      setPrescriptionSendSuccess(true);
    }
    if (
      next_appointment &&
      (next_appointment?.sendWhatsapp || next_appointment?.sms)
    ) {
      setNextAppntSendSuccess(true);
    }
  }, [details]);

  /** Adding New row */
  const addRow = () => {
    formik.setValues({
      ...formik.values,
      treatment_done_info: [
        ...formik.values.treatment_done_info,
        treatmentInfo,
      ],
    });
  };

  /** Removing row using index */
  const removeRow = (index) => {
    const updatedItems = [...formik.values.treatment_done_info];
    if (updatedItems.length !== 1) updatedItems.splice(index, 1);
    formik.setValues({
      ...formik.values,
      treatment_done_info: updatedItems,
    });
    calculateTotal(updatedItems);
  };

  const getMedicines = () => {
    getAllMedicines(search)
      .then((response) => {
        setMedicines(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    getMedicines();
  }, [search]);

  const formik = useFormik({
    initialValues: {
      patient_id: details?.patient_id?._id,
      date: details?.date,
      treatment_done_info: details?.medicine_info,
      treatment_amount: details.treatment_amount,
      total_amount: details.total_amount,
      discount: details?.discount,
      balance: details?.oldBalance,
      paymentIn: {
        date: new Date(),
        cash: 0,
        upi: 0,
        card: 0,
        bankTransfer: 0,
        amountPaid: 0,
        notes: details?.notes,
      },
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const hasInvalidMedicine = values.treatment_done_info.some(
        (selected) =>
          !medicines.some((valid) => valid.name === selected.medicine)
      );
      if (hasInvalidMedicine) {
        showErrorToast(
          "Invalid medicine selected. Please select valid medicines."
        );
        setLoading(false);

        return; // Early return to prevent further execution
      }
      // Check if the balance is less than 0
      if (values?.balance < 0) {
        // Display an error or take appropriate action
        showErrorToast({ customError: "Balance cannot be negative." });
        return;
      }
      // Create medicine_info array with batch details
      const medicine_info = values.treatment_done_info
        .filter((item) => item.name)
        .map((item) => ({
          name: item.name,
          quantity: item.quantity || 0,
          amount: round2(item.amount || 0),
          // Prefer the real medicine reference; item._id is only correct for
          // rows freshly picked from the dropdown (on loaded rows it is the
          // subdocument id).
          medicine_id:
            item?.medicine_id?._id || item?.medicine_id || item?._id || "",
          batches:
            item.batchDetails && item.batchDetails.length > 0
              ? item.batchDetails.map((batch) => ({
                  item_id: item.item_id,
                  stock_id: batch._id,
                  item_name: item.name,
                  batch_no: batch.batch,
                  quantity: batch.quantity,
                }))
              : [],
        }));

      const payload = {
        date: formatDate(values.date),
        patient_id: patientId,
        medicine_info: medicine_info,
        medicine_amount: round2(values.treatment_amount),
        total_amount: roundWhole(values.total_amount),
        discount: values.discount || 0,
        status: "Pending",
        sendWhatsapp: false,
        sendSms: false,
        isdeleted: false,
        notes: values?.paymentIn?.notes || "",
        paymentIn: {
          ...values.paymentIn,
          date: formatDate(values.paymentIn.date),
        },
      };

      if (details?.patient_id) {
        setLoading(true);
        updateMedBill(payload, details?._id)
          .then((response) => {
            showSuccessToast("Invoice Updated");
            handleEdit();
          })
          .catch((error) => {
            showErrorToast(error);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        showErrorToast({ customError: "Patient Profile is Required" });
      }
    },
  });
  useEffect(() => {
    if (!details?.medicine_info?.length) return;

    const hasExistingBatchDetails = formik?.values?.treatment_done_info?.some(
      (item) => item?.batchDetails?.length > 0
    );

    if (hasExistingBatchDetails) return;

    const transformedTreatmentInfo = details.medicine_info.map((item) => {
      const normalizedBatchDetails =
        item?.batchDetails?.length > 0
          ? item.batchDetails
          : (item?.batches || []).map((batch) => ({
              _id: batch?.stock_id || batch?._id,
              stock_id: batch?.stock_id || batch?._id,
              batch: batch?.batch_no || batch?.batch,
              quantity: batch?.quantity || 0,
              expiry_date: batch?.expiry_date,
              purchase_date: batch?.purchase_date,
              invoice_number: batch?.invoice_number,
            }));

      return {
        ...item,
        batchDetails: normalizedBatchDetails,
        // The stored line has no top-level item_id — the real owner id lives
        // on each batch. NEVER fall back to item._id: that is the
        // medicine_info SUBDOCUMENT's own id, not an inventory item, and
        // sending it made updateMedBill's ownership guard reject every edit
        // (and, before the guard, silently skipped the master-stock update).
        item_id:
          item?.item_id || item?.batches?.[0]?.item_id || item?.itemId || null,
      };
    });

    formik.setFieldValue("treatment_done_info", transformedTreatmentInfo);
  }, [details?.medicine_info]);

  const calculateTotal = (params) => {
    try {
      // Calculate the total amount
      const updatedAmounts = params.map((item, i) => item.amount);

      const newTotalAmount = updatedAmounts?.reduce(
        (acc, amount) => acc + parseFloat(amount),
        0
      );
      /** Set to formik */
      if (newTotalAmount)
        formik.setFieldValue("treatment_amount", round2(newTotalAmount));
      if (newTotalAmount)
        formik.setFieldValue("total_amount", roundWhole(newTotalAmount));
      const newBalance =
        parseFloat(newTotalAmount) - formik?.values?.paymentIn?.amountPaid;
      if (newBalance >= 0)
        formik.setFieldValue("balance_amount", roundWhole(newBalance));
      if (newBalance >= 0)
        formik.setFieldValue("balance", roundWhole(newBalance));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const allTotal = formik?.values?.treatment_done_info?.reduce(
      (sum, treatment) => sum + (parseFloat(treatment?.amount) || 0),
      0
    );
    const discountedTotal =
      allTotal - (parseFloat(formik.values?.discount) || 0);
    // Calculate amountPaid and balance based on the discount and existing balance
    const balanceTotal = discountedTotal;
    formik.setFieldValue("total_amount", roundWhole(balanceTotal));
  }, [formik.values.discount, formik.values.treatment_done_info]);

  /** For calculation of Balance amount */

  const calculateBalance = async () => {
    try {
      const amountPaid =
        details?.oldTotalPayment + formik.values?.paymentIn?.amountPaid;
      // Calculate the total amount whenever any of the inputs change
      const newBalance = roundWhole(formik.values.total_amount - amountPaid);
      formik.setFieldValue("balance", newBalance);

      if (formik.values.total_amount === 0) {
        setStatus("Free Visit");
      } else if (formik.values.total_amount === newBalance) {
        setStatus("Pending");
      } else if (newBalance === 0) {
        setStatus("Paid");
      } else if (newBalance > 0) {
        setStatus("Partially-Paid");
      } else setStatus("ERROR");
    } catch (error) {
      console.error(error);
    }
  };
  /** For calculating the total amount */

  const calculateTotalAmount = () => {
    try {
      const allTotal = formik?.values?.treatment_done_info?.reduce(
        (sum, treatment) => sum + (parseFloat(treatment?.amount) || 0),
        0
      );

      const discountedTotal =
        allTotal - (parseFloat(formik.values?.discount) || 0);
      // Calculate amountPaid and balance based on the discount and existing balance
      const balanceTotal = discountedTotal;
      formik.setFieldValue("total_amount", roundWhole(balanceTotal));
      formik.setFieldValue("treatment_amount", round2(allTotal));
    } catch (error) {
      console.error(error);
    }
  };

  const handleSaveBatchDetails = (batchDetailsObject, totalQuantity = 0) => {
    // Store batch details in formik for the selected medicine item
    if (selectedRowData && batchDetailsObject) {
      const medicineIndex = formik.values.treatment_done_info.findIndex(
        (item) => item.name === selectedRowData.name
      );

      if (medicineIndex !== -1) {
        const currentMedicine =
          formik.values.treatment_done_info[medicineIndex] || {};
        // Update the medicine item with batch details
        const updatedMedicine = {
          ...currentMedicine,
          batchDetails: batchDetailsObject,
          item_id: selectedRowData._id,
        };

        const numericTotalQuantity = Number(totalQuantity) || 0;
        const existingQuantity = Number(currentMedicine?.quantity) || 0;

        if (numericTotalQuantity > 0 && existingQuantity === 0) {
          updatedMedicine.quantity = numericTotalQuantity;

          const unitPrice = Number(currentMedicine?.actualAmount)
            ? Number(currentMedicine.actualAmount)
            : existingQuantity > 0 && Number(currentMedicine?.amount)
            ? Number(currentMedicine.amount) / existingQuantity
            : Number(currentMedicine?.amount) || 0;

          if (unitPrice) {
            updatedMedicine.amount = round2(unitPrice * numericTotalQuantity);
          }
        }

        const updatedTreatmentInfo = [...formik.values.treatment_done_info];
        updatedTreatmentInfo[medicineIndex] = updatedMedicine;

        formik.setFieldValue("treatment_done_info", updatedTreatmentInfo);
        if (numericTotalQuantity > 0) {
          setSelectedRowData((prev) => ({
            ...prev,
            quantity: numericTotalQuantity,
          }));
        }
      }
    }
    setOpenBatchDetails(false);
  };

  const sendNextappointment = () => {
    const payload = {
      appointmentId: next_appointment?._id,
      ...communicationChannel,
    };
    if (payload.sms || payload.whatsapp) {
      sendNextappointmentMessage(payload)
        .then((response) => {
          showSuccessToast("Nextappointment Send Successfully");
          setNextAppntSendSuccess(true);
        })
        .catch((error) => {
          console.log(error);
          showErrorToast(error, "error");
        })
        .finally(() => {
          setNextAppntLoading(false);
        });
    } else {
      showErrorToast(
        {
          customError: "Please Select any Communication Channel",
        },
        "error"
      );
    }
  };

  const sendPrescription = () => {
    const payload = {
      prescriptionId: prescription?._id,
      ...communicationChannel,
    };
    if (payload.sms || payload.whatsapp) {
      setPrescriptionLoading(true);
      sendPrescriptionMessage(payload)
        .then((response) => {
          showSuccessToast("Prescription Send Successfully");
          setPrescriptionSendSuccess(true);
        })
        .catch((error) => {
          console.log(error);
          showErrorToast(error, "error");
        })
        .finally(() => {
          setPrescriptionLoading(false);
        });
    } else {
      showErrorToast(
        {
          customError: "Please Select any Communication Channel",
        },
        "error"
      );
    }
  };

  const sendInvoice = () => {
    const payload = { invoiceId: details?._id, ...communicationChannel };
    if (payload.sms || payload.whatsapp) {
      setInvoiceLoading(true);
      sendMedBillInvoiceMessage(payload)
        .then((response) => {
          showSuccessToast("Invoice Send Successfully");
          setInvoiceSendSuccess(true);
          /** Open Whatsapp for essentials subscription users */
          openWhatsappMessager(response.data?.essentials_whatsapp_url);
        })
        .catch((error) => {
          console.log(error);
          showErrorToast(error, "error");
        })
        .finally(() => {
          setInvoiceLoading(false);
        });
    } else {
      showErrorToast(
        {
          customError: "Please Select any Communication Channel",
        },
        "error"
      );
    }
  };
  // Check if running as PWA
  const isPWA = () => {
    return (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone ||
      document.referrer.includes("android-app://")
    );
  };

  const printPrescription = () => {
    setLoadingPrintPrescription(true);
    getPrescriptionPrint(prescription?._id)
      .then(({ blob }) => {
        const fileURL = window.URL.createObjectURL(blob);

        if (isPWA()) {
          // For PWA: Download the file
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = `prescription_${
            prescription?._id || "prescription"
          }.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          // Clean up the object URL after a delay
          setTimeout(() => {
            window.URL.revokeObjectURL(fileURL);
          }, 100);
          showSuccessToast("Prescription downloaded successfully");
        } else {
          // For web: Open in new window
          window.open(fileURL);
        }
      })
      .catch((error) => {
        console.log(error);
        showErrorToast(error, "error");
      })
      .finally(() => {
        setLoadingPrintPrescription(false);
      });
  };
  const printInvoice = () => {
    setLoadingPrintInvoice(true);
    getMedBillInvoicePrint(details?._id)
      .then(({ blob }) => {
        const fileURL = window.URL.createObjectURL(blob);

        if (isPWA()) {
          // For PWA: Download the file
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = `med_invoice_${details?._id || "invoice"}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          // Clean up the object URL after a delay
          setTimeout(() => {
            window.URL.revokeObjectURL(fileURL);
          }, 100);
          showSuccessToast("Invoice downloaded successfully");
        } else {
          // For web: Open in new window
          window.open(fileURL);
        }
      })
      .catch((error) => {
        console.log(error);
        showErrorToast(error, "error");
      })
      .finally(() => {
        setLoadingPrintInvoice(false);
      });
  };
  // Returns the API promise so PasswordConfirmModal stays "loading"
  // until the actual delete settles.
  const handleDelete = () => {
    return deleteMedBill(details?._id)
      .then(() => {
        showSuccessToast("Deleted Successfully");
        setConfirmOpen(false);
        navigation(-1);
      })
      .catch((error) => {
        console.log(error);
        showErrorToast(error, "error");
      });
  };

  const getTheBills = () => {
    getPaymentHistory();
  };

  useEffect(() => {
    getTheBills();
  }, [details]);

  useEffect(() => {
    calculateTotalAmount();
  }, [formik.values.discount, formik.values.treatment_done_info]);

  useEffect(() => {
    calculateBalance();
  }, [pendingInv, formik.values.total_amount, formik.values.paymentIn]);

  /** calculation of Balance amount end */
  return (
    <>
      <form
        onSubmit={formik.handleSubmit}
        className="flex flex-col gap-4 pb-12"
      >
        <div
          id="block"
          className="flex flex-col lg:flex-row gap-3 lg:justify-between lg:items-center"
        >
          <div className=" flex flex-col lg:flex-row gap-3 "></div>
          <div className="lg:flex items-center gap-3">
            <p className="text-bodyBB text-darkgrey">Bill Date</p>
            <DatePicker
              className={"lg:!w-[260px] !h-[50px]"}
              startDate={
                new Date(dayjs(formik.values.date).format("YYYY-MM-DD"))
              }
              disabled={!edit}
              onDateChange={(e) => {
                formik.setFieldValue("date", e);
              }}
              error={formik.touched.date && formik.errors.date}
            />
          </div>
        </div>
        {/* Conditionaly rendering profile section  */}
        {details?.patient_id && (
          <div>
            <ProfileSection patientProfile={details?.patient_id} />
          </div>
        )}

        {/* Medicine info + Payment History.
            - Desktop/tablet (≥ lg): side-by-side via `grid-flow-col
              auto-cols-fr`, matching the original layout.
            - Mobile (< lg): single column — each section spans the full
              viewport, fixing the earlier bug where payment history was
              squeezed to half width and only the Date column was visible. */}
        <div className="grid grid-cols-1 lg:grid-flow-col lg:auto-cols-fr gap-1 ">
          <ServiceMedicineInfo
            formik={formik}
            addRow={addRow}
            removeRow={removeRow}
            treatments={medicines}
            setTreatments={setTreatments}
            search={search}
            edit={edit}
            setSearch={setSearch}
            handleGetMedDetails={handleGetMedDetails}
          />
          <div className="shadow-card rounded-15 overflow-x-auto lg:overflow-visible">
            <div className="min-w-max lg:min-w-0">
              <div
                className={`shadow-card rounded-tl-15 rounded-tr-15 bg-secondary p-3 text-bodyBB text-darkgrey mb-2 `}
              >
                Payment History
              </div>
              <PaymentTransaction
                status={status}
                getpendingInvoices={getPaymentHistory}
                pendingInvoices={paymentHistory}
                edit={edit}
                getInvoiceDetails={getInvoiceDetails}
                totalAmount={details?.total_amount}
              />
            </div>
          </div>
        </div>

        <PaymentInfo formik={formik} edit={edit} details={details} />
        {!edit && (
          <div className="lg:flex justify-between items-start">
            <div className="grid grid-cols-2 gap-2">
              <div className="">
                <p className="text-bodyRB">Communications</p>
                <div className="shadow-card rounded-15 flex justify-center p-2">
                  <div className="flex items-center gap-1">
                    <input
                      checked={communicationChannel?.whatsapp}
                      onChange={handleWhatsappClick}
                      type="checkbox"
                      className="h-[14px] w-[14px] accent-pink  rounded focus:accent-pink-500"
                    />
                    <p className="text-bodyRB text-darkgrey">Whatsapp</p>
                    <div className="mt-1">
                      <Whatsapp />
                    </div>
                  </div>
                  <div className="flex items-center gap-1">
                    <input
                      onChange={handleSmsClick}
                      checked={communicationChannel?.sms}
                      type="checkbox"
                      className="h-[14px] w-[14px] accent-pink  rounded focus:accent-pink-500"
                    />
                    <p className="text-bodyRB text-darkgrey">SMS</p>
                    <div className="mt-1">
                      <SMS />
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                <p className="text-bodyRB">Messaging</p>
                <div className="shadow-card rounded-15 flex flex-col justify-center p-2 gap-2">
                  {next_appointment && (
                    <Button
                      action={"button"}
                      type={"yes"}
                      className={"!py-[5px] h-[40px]"}
                      loading={nextAppntLoading}
                      onClick={sendNextappointment}
                    >
                      {nextAppntSendSuccess && <CheckMarkWhite />}
                      Next Appnt
                    </Button>
                  )}
                  {prescription && (
                    <Button
                      action={"button"}
                      type={"yes"}
                      className={"!py-[5px] h-[40px]"}
                      onClick={sendPrescription}
                      loading={prescriptionLoading}
                    >
                      {prescriptionSendSuccess && <CheckMarkWhite />}
                      Prescription
                    </Button>
                  )}
                  <Button
                    type={"yes"}
                    action={"button"}
                    className={"!py-[5px] h-[40px]"}
                    loading={invoiceLoading}
                    onClick={sendInvoice}
                  >
                    {invoiceSendSuccess && <CheckMarkWhite />}
                    Invoice
                  </Button>
                </div>
              </div>
            </div>
            <div className="grid lg:grid-cols-3 col-span-2 col-start-4 gap-2 items-center">
              <div className="">
                <p className="text-bodyRB">Print</p>
                <div className="shadow-card rounded-15 flex flex-col gap-2 justify-center p-2 items-center">
                  {prescription && (
                    <Button
                      onClick={printPrescription}
                      action={"button"}
                      loading={loadingPrintPrescription}
                      className={
                        "bg-pink-gradient text-white !py-[5px] h-[40px]"
                      }
                    >
                      <Printer />
                      Prescription
                    </Button>
                  )}
                  <Button
                    onClick={printInvoice}
                    loading={loadingPrintInvoice}
                    action={"button"}
                    className={"bg-pink-gradient text-white !py-[5px] h-[40px]"}
                  >
                    <Printer />
                    Invoice
                  </Button>
                </div>
              </div>
              <div className="mt-5">
                <Button
                  onClick={() => {
                    handleconfirmation();
                  }}
                  action={"button"}
                  type={"danger"}
                  className={"!py-[5px] h-[45px] lg:!w-[200px]"}
                >
                  Delete
                </Button>
              </div>
              <div className="mt-5">
                <Button
                  onClick={handleEdit}
                  action={"button"}
                  type={"primary"}
                  className={"!py-[5px] h-[45px] lg:!w-[200px]"}
                >
                  Edit
                </Button>
              </div>
            </div>
          </div>
        )}
        {edit && (
          <div className="grid lg:grid-cols-3">
            <div className="flex flex-col md:flex-row lg:col-start-3 gap-3">
              <Button action={"button"} type={"danger"} onClick={handleEdit}>
                Cancel
              </Button>
              <Button loading={loading} type={"primary"}>
                Save
              </Button>
            </div>
          </div>
        )}
        <PasswordConfirmModal
          open={confirmOpen}
          onClose={() => setConfirmOpen(false)}
          title={"Are you sure that you want to delete this medicine bill?"}
          message={details?.SI_NO ? `#${details.SI_NO}` : undefined}
          onConfirm={handleDelete}
        />
      </form>

      <ModalWrapper
        open={openBatchDetails}
        handleClose={() => setOpenBatchDetails(false)}
        className={"p-0"}
      >
        <BatchDetails
          handleSaveBatchDetails={handleSaveBatchDetails}
          batchDetails={batchDetails}
          formik={formik}
          edit={true}
          selectedRowData={selectedRowData}
        />
      </ModalWrapper>
    </>
  );
};

export default MedicinePaymentDetailsLayout;
